import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import { httpClient } from 'services/httpClient';
import IWorkerDeleteRequestBody from 'services/httpClient/requests/worker/IWorkerDeleteRequestBody';
import IEditWorkerResponse from 'services/httpClient/responses/worker/IEditWorkerResponse';

import { workerActions } from '../index';
import { IWorkerDeleteRequestAction } from '../reducers/delete/request';

function* deleteWorker(action: PayloadAction<IWorkerDeleteRequestAction>) {
  try {
    const body: IWorkerDeleteRequestBody = {
      id: action.payload.data.id,
      active: action.payload.data.active,
    };

    const { data }: AxiosResponse<IEditWorkerResponse> = yield call(
      httpClient.put,
      `/rik/v1/workers/${action.payload.data.id}`,
      body,
    );

    yield put(workerActions.deleteSuccess({ worker: data }));
    action.payload.functions.handleClose();
  } catch (err: any) {
    action.payload.functions.error(err);
    yield put(workerActions.deleteFailure());
  }
}

export default deleteWorker;
